import { Holding } from '../api/portfolio';
import { getCompanyName } from './companyNames';

export function exportPortfolioToCSV(portfolio: Holding[]) {
  // Calculate totals
  const totalValue = portfolio.reduce((sum, h) => sum + (h.totalValue || 0), 0);
  
  // Create CSV header
  const headers = ['Symbol', 'Company Name', 'Shares', 'Current Price', 'Total Value', 'Percentage', 'Created At', 'Updated At'];
  
  // Create CSV rows
  const rows = portfolio.map(holding => {
    const percentage = totalValue > 0 ? ((holding.totalValue || 0) / totalValue * 100).toFixed(2) : '0.00';
    const createdDate = new Date(holding.created_at).toLocaleDateString();
    const updatedDate = new Date(holding.updated_at).toLocaleDateString();
    
    return [
      holding.symbol,
      getCompanyName(holding.symbol),
      holding.shares.toFixed(4),
      holding.currentPrice?.toFixed(2) || '0.00',
      (holding.totalValue || 0).toFixed(2),
      percentage + '%',
      createdDate,
      updatedDate
    ];
  });
  
  // Add summary row
  rows.push([]);
  rows.push(['TOTAL', '', '', '', totalValue.toFixed(2), '100.00%', '', '']);
  
  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n');
  
  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `portfolio_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
